import Base from './Base';

class Request extends Base {
    constructor () {
        super();
        this.endpoint = 'cards';
    }


    
}

export default Request;